var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.$store.getters.totalEmploymentHistory < _vm.requiredYears)?_c('p',[_vm._v("Next, we'll need another "+_vm._s(_vm.needed)+" of your employment history.")]):_vm._e(),(!_vm.first && _vm.$store.getters.totalEmploymentHistory >= _vm.requiredYears)?_c('p',[_vm._v("Great, that's all the information we need.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }